export default __webpack_public_path__ + "static/media/dev-img.4f758131.png";